// Discount helpers shared by invoice lines and the invoice-level discount.
// Mirrors invoice.models.discount_amount_of on the backend.

export const DISCOUNT_TYPE_OPTIONS = [
  { value: "PERCENT", label: "Percent (%)" },
  { value: "FIXED", label: "Fixed Amount" },
];

// Discount taken off `amount`, never more than the amount itself.
export const discountAmountOf = (amount, discountType, discountValue) => {
  const base = Number(amount) || 0;
  const value = Number(discountValue) || 0;
  if (!discountType || value <= 0 || base <= 0) {
    return 0;
  }
  const discount =
    discountType === "PERCENT" ? (base * Math.min(value, 100)) / 100 : value;
  return Number(Math.min(discount, base).toFixed(2));
};

// Line total as the line forms store it: (qty x price - discount) plus the
// line's own taxes. `rates` are fractions, e.g. 0.18 for 18%.
export const discountedLineTotal = (
  quantity,
  price,
  discountType,
  discountValue,
  rates = []
) => {
  const gross = (Number(quantity) || 0) * (Number(price) || 0);
  const base = gross - discountAmountOf(gross, discountType, discountValue);
  const taxRate = rates.reduce((sum, rate) => sum + (Number(rate) || 0), 0);
  return Number((base + base * taxRate).toFixed(2));
};

export const formatDiscount = (discountType, discountValue) => {
  const value = Number(discountValue) || 0;
  if (!discountType || value <= 0) {
    return null;
  }
  return discountType === "PERCENT" ? `${value} %` : `${value.toFixed(2)}`;
};
